// apps/client/src/assets/shared.ts (title screen, 2026-10-05) — the page's one AssetService. The title's showcase town loads the kits
// through it, so a town entered after the title finds them loaded; the creator's preview reads the same rig.
import { createAssetService, type AssetService } from './service';

let shared: AssetService | null = null;
export function pageAssets(): AssetService { return (shared ??= createAssetService()); }
